<template>
	<div>
		<modal class="ml-3" container-style="max-width: 600px;" v-model="modalOpen" :hideCloseButton="true">
			<div class="insurance-info insurance-popup">
				<ximg
					v-if="! showParaEsport"
					:src="headerSrc"
					:ariaLabel="insuranceInfo.header + ' banner'"
					role="img"
				/>
				<h2 class="level-one-heading">{{ insuranceInfo.header }}</h2>
				<ul>
					<li v-for="(row, key) in insuranceText" :key="key">
						<span>{{ row }}</span>
					</li>
				</ul>
				<template v-if="showParaEsport">
					<ximg
						class="para"
						:src="headerSrc"
						ariaLabel="PARA Esports"
						role="img"
					/>
					<p>
						Tillsammans med Trygg-Hansa skänker vi just nu
						<span class="semibold">25 kr per såld försäkring till PARA Esports</span>,
						med målet att hjälpa gamers med
						funktionsvariationer att uppfylla sina drömmar.
					</p>
				</template>
				<hr/>
				<div class="insurance-popup-price">
					<ximg
						v-if="showIcon"
						:src="categoryIconUrl(icon, false, '333')"
						:ariaLabel="icon + ' ikon'"
						role="img"
					/>
					<strong>Trygghetsavtal 12 mån</strong>
					<product-price class="ml-auto" :product="insurance" :row="true" :priceOverride="insuranceInfo.price" />
				</div>
				<div class="d-flex mb-5">
					<router-link target="_blank" to="/campaign/10308-Care-Pack-Trygghetsavtal">Läs mer</router-link>
					<p v-if="insuranceInfo.monthly" class="ml-auto">({{insuranceInfo.monthly}} kr/mån)</p>
				</div>
				<hr/>
				<div class="add-insurance">
					<text-button
						text="Lägg till försäkring"
						width="stretch"
						@click="addInsuranceToCart(true)"
					/>
					<text-button
						text="Nej tack, jag klarar mig"
						variant="secondary"
						width="stretch"
						@click="addInsuranceToCart(false)"
					/>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import bus from 'eventbus';
import { mapState } from 'vuex';
import { convertToCdnUrl, categoryIconUrl } from 'utils';

export default {
	props: {
		insurance: {
			type: Object,
			default: () => {},
		},
		icon: {
			type: String,
			default: '',
		},
		product: {
			type: Object,
			default: () => {},
		},
		showAccessoriesPopup: {
			type: Number,
			default: 0,
		},
		productCategories: {
			type: Array,
			default: () => {},
		}
	},
	data () {
		return {
			bus,
			categoryIconUrl,
			convertToCdnUrl,
			modalOpen: false,
		};
	},
	computed: {
		insuranceInfo () {
			const header = 'Om oturen är framme';
			const price = this.insurance.price;
			const monthly = Math.ceil(price / this.insurance.length);
			delete this.insurance.price;  /*removes price, so that <product-price/> doens't try to read it from the :product.*/
			return { header, price, monthly };
		},
		insuranceText () {
			return [
				'Skydd mot olyckshändelse, funktionsfel och stöld',
				this.productCategories.find(category => category.id === 2)
				? 'Inget åldersavdrag, 499 kr självrisk för mobiltelefoner'
				: 'Inget åldersavdrag, ingen självrisk',
				'Likvärdig ersättningsprodukt upp till 100% av inköpspriset'
			];
		},
		headerSrc () {
			return this.showParaEsport ? convertToCdnUrl('/img/para-esports.jpg') : convertToCdnUrl('/images/620514-infoservice2022');
		},
		insuranceTermsUrl() {
			return convertToCdnUrl('/pdf/CarePack-informationsbroschyr.pdf');
		},
		showIcon () {
			return this.icon !== '' || this.icon !== null;
		},
		showParaEsport () {
			const endDate = new Date('2024/03/31 23:59:59');
			const now = new Date();
			return now < endDate;
		},
		...mapState({
			cart: state => state.cart,
		}),
	},
	methods: {
		addInsuranceToCart(add) {
			if (add) {
				// Match the product in the cart with main product, in case of bundle
				const row = this.cart.rows.find(obj => {
					return obj.product.id === this.product.id
				});
				const data = {
					price: row.unitPrice,
					key: 'insured',
					value: true,
					trackingData: {
						source: this.$route.name === 'product' ? 'Product page popup' : this.$route.name,
						event: 'addToCart',
						isInsurance: true,
						insurance: row.insurance,
					},
					...row,
				}
				//add update the product with insurance.
				this.$store.dispatch('cart/updateRow', data);

				this.bus.$emit('modal.close');

				if (this.showAccessoriesPopup) {
					this.$emit('triggerAccessoriesPopup');
				}
			}

			this.bus.$emit('modal.close');

			if (this.showAccessoriesPopup) {
				this.$emit('triggerAccessoriesPopup');
			}
		},
	},
};
</script>
